export const CREATE_BG_GALLERY_REQUEST = "CREATE_BG_GALLERY_REQUEST";
export const CREATE_BG_GALLERY_SUCCESS = "CREATE_BG_GALLERY_SUCCESS";
export const CREATE_BG_GALLERY_FAIL = "CREATE_BG_GALLERY_FAIL";

export const FETCH_BG_GALLERY_REQUEST = "FETCH_BG_GALLERY_REQUEST";
export const FETCH_BG_GALLERY_SUCCESS = "FETCH_BG_GALLERY_SUCCESS";
export const FETCH_BG_GALLERY_FAIL = "FETCH_BG_GALLERY_FAIL";

export const DELETE_BG_GALLERY_REQUEST = "  DELETE_BG_GALLERY_REQUEST";
export const DELETE_BG_GALLERY_SUCCESS = "  DELETE_BG_GALLERY_SUCCESS";
export const DELETE_BG_GALLERY_FAIL = " DELETE_BG_GALLERY_FAIL";

export const SHOW_BG_GALLERY_REQUEST = "  SHOW_BG_GALLERY_REQUEST";
export const SHOW_BG_GALLERY_SUCCESS = "  SHOW_BG_GALLERY_SUCCESS";
export const SHOW_BG_GALLERY_FAIL = " SHOW_BG_GALLERY_FAIL";

export const UPDATE_BG_GALLERY_REQUEST = "  UPDATE_BG_GALLERY_REQUEST";
export const UPDATE_BG_GALLERY_SUCCESS = "  UPDATE_BG_GALLERY_SUCCESS";
export const UPDATE_BG_GALLERY_FAIL = " UPDATE_BG_GALLERY_FAIL";
